import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteProvider } from "@/context/SiteContext";
import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import Buy from "@/pages/Buy";
import DigitalEdition from "@/pages/DigitalEdition";
import ListingOptions from "@/pages/ListingOptions";
import Questionnaire from "@/pages/Questionnaire";
import MediaKit from "@/pages/MediaKit";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import SchoolPage from "@/pages/School";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import Listings from "@/admin/Listings";
import Groups from "@/admin/Groups";
import MenuManager from "@/admin/MenuManager";
import ContentEditor from "@/admin/ContentEditor";
import MediaLibrary from "@/admin/MediaLibrary";

const NotFound = () => (
  <div className="max-w-3xl mx-auto px-6 py-28 text-center" data-testid="not-found-page">
    <h1 className="font-serif text-4xl font-bold">Page not found</h1>
    <Link to="/" className="mt-6 inline-block text-brand underline" data-testid="not-found-home-link">Back to home</Link>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <SiteProvider>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/buy" element={<Buy />} />
            <Route path="/digital-edition" element={<DigitalEdition />} />
            <Route path="/listing-options" element={<ListingOptions />} />
            <Route path="/listing-questionnaire" element={<Questionnaire />} />
            <Route path="/media-kit" element={<MediaKit />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/school/:slug" element={<SchoolPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Listings />} />
            <Route path="groups" element={<Groups />} />
            <Route path="menu" element={<MenuManager />} />
            <Route path="content" element={<ContentEditor />} />
            <Route path="media" element={<MediaLibrary />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </SiteProvider>
    </BrowserRouter>
  );
}

export default App;
